import styled from "@emotion/styled";

import { pxToRem } from "@src/utils";

export const StyledButtonsContainer = styled.div`
  display: flex;
  gap: ${pxToRem(16)};

  .reset-button::part(button) {
    background-color: grey;
  }
`;
